import { State } from './state.type';

export const stateInitializer = (): State => {
	return {
		firstName: 'John',
		lastName: 'Doe'
	};
};
